module.exports = __webpack_public_path__ + "static/media/blank.784af16b.png";